<script lang="ts">
  // `dl.details` under the auth banner (spec §10): to / cc / Return-Path / Message-ID / source link.
  import { t } from '$lib/i18n';
  import { formatPerson } from '$lib/mail/format';
  import type { Address } from '$lib/types';

  let {
    to,
    cc,
    returnPath,
    messageId,
    srcUrl,
  }: {
    to: readonly Address[];
    cc: readonly Address[];
    returnPath: string | null | undefined;
    messageId: string | null | undefined;
    srcUrl: string;
  } = $props();

  const join = (list: readonly Address[]) => list.map(formatPerson).filter(Boolean).join('، ');
</script>

<dl class="details">
  <dt>{t('to')}</dt>
  <dd><bdi>{join(to) || ' '}</bdi></dd>
  {#if cc.length}
    <dt>{t('cc')}</dt>
    <dd><bdi>{join(cc)}</bdi></dd>
  {/if}
  {#if returnPath}
    <dt>Return-Path</dt>
    <dd dir="ltr">{returnPath}</dd>
  {/if}
  {#if messageId}
    <dt>Message-ID</dt>
    <dd dir="ltr">{messageId}</dd>
  {/if}
  <dt></dt>
  <dd><a target="_blank" rel="noopener" href={srcUrl}>{t('viewSource')}</a></dd>
</dl>

<style>
  /* svelte-rwh28b (Reader) — details */
  .details {
    display: grid;
    grid-template-columns: auto 1fr;
    gap: 4px var(--space-3);
    font-size: var(--text-xs);
    line-height: var(--leading-body);
    background: var(--surface-subtle);
    border-radius: var(--radius-md);
    padding: var(--space-3);
    margin-bottom: var(--space-3);
    overflow-wrap: anywhere
  }

  .details dt {
    color: var(--text-faint)
  }

  .details dd {
    margin: 0;
    color: var(--text-body)
  }
</style>
